import { render, staticRenderFns } from "./LabelInfo.vue?vue&type=template&id=04ec5a36&scoped=true&"
import script from "./LabelInfo.vue?vue&type=script&lang=js&"
export * from "./LabelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec5a36",
  null
  
)

export default component.exports